import { isIOS, iosVersion } from "../utilities/globalUtilities";

/**
 * @function
 * @description - Initialize tooltips
 * @param {String} [selector] - tooltip container
 */
const initTooltip = selector => {
    const $tooltips = $(`${selector ? selector : ""} [data-toggle="tooltip"]`).tooltip({
        trigger : "hover"
    });

    $tooltips.each((index, element) => {
        const inputTooltipsElements = ["input", "textarea"];
        let triggerType = inputTooltipsElements.includes(element.tagName.toLowerCase()) ? "click hover" : "hover";
        const $element = $(element);
        const $elementInModal = $element.closest(".modal");
        const isTooltipInModal = $elementInModal.length != 0 && !$elementInModal.hasClass("suggestions");
        let tooltipContainerSelector = isTooltipInModal ? $element.closest(".modal-content")[0] : (selector || "body");

        if (!$element.attr("data-original-title")) {
            $element.tooltip({
                trigger: triggerType,
                container: tooltipContainerSelector
            });
        }

        $element.on("shown.bs.tooltip", e => {
            const $this = e.currentTarget;
            let version = isIOS() ? iosVersion() : "";

            if (isIOS() && (version == "11" || version == "12")) {
                $this.click();
            }
        });
    });

    const $inputTooltips =  $("input[data-toggle='tooltip']");

    $inputTooltips.each((index, element) => {
        $(element).on("shown.bs.tooltip", e => {
            const tooltipID = e.currentTarget.getAttribute("aria-describedby");

            document.querySelector(`#${tooltipID}`).classList.add("input-tooltip");
        });
    });

    const $quickviewTooltips =  $(".js-product-quickview [data-toggle='tooltip']");

    $quickviewTooltips.each((index, element) => {
        $(element).on("shown.bs.tooltip", e => {
            const tooltipID = e.currentTarget.getAttribute("aria-describedby");

            document.querySelector(`#${tooltipID}`).classList.add("quickview-tooltip");
        });
    });

    const $modalCloseTooltips = $(".close[data-toggle='tooltip']");

    $modalCloseTooltips.each((index, element) => {
        $(element).on("shown.bs.tooltip", e => {
            const tooltipID = e.currentTarget.getAttribute("aria-describedby");

            document.querySelector(`#${tooltipID}`).classList.add("on-top-tooltip");
        });
    });
};

export { initTooltip };
